import axios from '../http'
import config from '../../../config'
import {
  AUTH,
  USER_DATA,
  VEHICLES_ACTIVE,
  VEHICLES,
  PARTNERS,
  USERS_AUTHORITIES,
  STORES,
  USERS,
  ADD_PASSWORD,
  EMAIL_RESET,
  FINISH_RESET_PASSWORD,
  DRIVERS,
  ADD_DRIVERS
} from '../endpoints'

const getAuth = payload => axios.post(AUTH, payload)
const getVehicles = () => axios.get(VEHICLES_ACTIVE)
const getDrivers = () => axios.get(DRIVERS)
const getPartners = () => axios.get(`${PARTNERS}/active`)
const getProfiles = () => axios.get(USERS_AUTHORITIES)
const getStores = () => axios.get(STORES)
const getUserData = () => axios.get(USER_DATA)

const setRegistration = params => {
  const {
    status = false,
    registrationId = false
  } = params

  delete params.status
  delete params.registrationId

  if (status) {
    params.id = registrationId
    return axios.put(VEHICLES, params)
  }

  return axios.post(VEHICLES, params)
}

const setPassword = payload => {
  if (payload.type && payload.type === config.data.urlQuery.type) {
    return axios.post(FINISH_RESET_PASSWORD, payload)
  }

  return axios.post(ADD_PASSWORD, payload)
}

const setNewUser = payload => axios.post(USERS, payload)
const setNewRequestPassword = payload => axios.post(EMAIL_RESET, payload)
const setDriver = payload => axios.put(ADD_DRIVERS, payload)
const deleteVehicles = id => axios.delete(`${VEHICLES}/${id}`)

export default {
  getAuth,
  getUserData,
  getVehicles,
  getPartners,
  getProfiles,
  getStores,
  getDrivers,
  setNewUser,
  setPassword,
  setRegistration,
  setDriver,
  setNewRequestPassword,
  deleteVehicles
}



// WEBPACK FOOTER //
// ./src/repository/api/user.js